import { useSelector } from 'react-redux';

export const useParamSelector = (selector: any, ...params: any) => {
    return useSelector(state => selector(state, ...params));
};